export enum DeviceStatus {
  ONLINE = "online",
  OFFLINE = "offline",
}

export enum DeviceAssetType {
  COMPANY_OWNED = "company_owned",
  PERSONAL = "personal",
}

export enum DeviceTagType {
  TAG = "tag",
  HOST = "host",
}
